/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import _ from 'lodash';
import request from 'superagent';
import cookie from '../helpers/cookie';
import config from '../config';


export default function APIRequest(method, apiUrl, query, data, callback) {
  const token = cookie.get('token');
  let url = config.apiBase + apiUrl;
  if (apiUrl.startsWith('http')) {
    url = apiUrl;
  }

  let rq = request[method](url).set('Authorization', `Bearer ${token}`);
  if (query) {
    rq = rq.query(query);
  }
  if (data) {
    rq = rq.send(data);
  }

  function normError(err, res) {
    const aRes = _.merge({
      body: {},
    }, res);

    return _.extend(
      {},
      res,
      {
        errcode: err.name,
        errmsg: err.message,
        error: err,
      },
      {
        errcode: aRes.body._code || aRes.body.error || 'UNKNOWN',
        errmsg: aRes.body._message || aRes.body.message || 'UNKNOWN',
        error: err,
      },
    );
  }

  function normResult(res) {
    const result = _.merge({ body: {} }, res);
    if (_.isNull(result.body.list)) {
      result.body.list = [];
    }
    return result;
  }

  return new Promise((resolve, reject) => {
    rq.end((err, res) => {
      let error = null;
      let result = null;

      if (err) {
        if (err.status === 401) {
          cookie.unset('token');
        }
        error = normError(err, res);
      } else if (res.statusCode !== 200) {
        error = normError(err, res);
      } else {
        result = normResult(res);
      }

      if (callback) {
        return callback(error, result);
      }
      if (error) {
        reject(error);
      } else {
        resolve(result);
      }
      return null;
    });
  });
}

export function saveToState(call, _this, targetKey) {
  return new Promise((resolve, reject) => {
    call.then((res) => {
      const obj = {};
      obj[targetKey] = res.body;
      _this.setState(obj, () => {
        resolve(res.body);
      });
    }, (err) => {
      reject(err);
    });
  });
}




// WEBPACK FOOTER //
// ./src/api/index.js